import * as HttpService from 'services/http.service';
import { GET_CITY_DETAILS } from 'services/url.service';

const getCityDetails = () => HttpService.getWithoutAuth(GET_CITY_DETAILS);

export default getCityDetails;
